import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  mostCostlyWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    alignItems: 'flex-start'
  },
  mostCostlyTitle: {
    flex: 1,
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200]
  },
  notUsed: {
    fontSize: 14,
    fontWeight: 200,
    color: colour.grey[400]
  }
});
